import { render, staticRenderFns } from "./EventListComponent.vue?vue&type=template&id=834fb0da&"
import script from "./EventListComponent.vue?vue&type=script&lang=js&"
export * from "./EventListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports